// LivestreamDetailOnlineFooterDesktop.js
'use strict';
import { connect } from 'react-redux';

import LivestreamDetailOnlineFooterDesktop from '../component/LivestreamDetailOnlineFooterDesktop.jsx';

import getOperationData from '../selector/getOperationData.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';
import { getIsToyDeviceOnline } from '../selector/getLivestreamComputedData.js';
import getModalData from '../selector/getModalData.js';
import getPrivateShowStatus from '../selector/getPrivateShowStatus.js';

import setLiveStreamPanel from '../action/setLiveStreamPanel.js';
import setPlayerData from '../action/setPlayerData.js';
import toggleModal from '../action/toggleModal.js';
import { ExclusivePrivateStatus } from '../resource/liveStreamConstants.js';
import {
  getIsAgoraStreamProvider,
  getIsTencentStreamProvider,
} from '../resource/livestreamUtils.js';

const mapStateToProps = (state, { streamId }) => {
  const streamStatus = getLiveStreamData(state, [streamId], 'status');
  const hasStreamToken = !!(
    getOperationData(
      state,
      ['liveStream', 'paid', streamId],
      'byteplusToken'
    ) ||
    getOperationData(state, ['liveStream', 'paid', streamId], 'streamToken')
  );

  const exclusivePrivateStatus = getLiveStreamData(
    state,
    [streamId, 'exclusivePrivate'],
    'status'
  );
  const isExclusivePrivatePerforming =
    ExclusivePrivateStatus.PERFORMING === exclusivePrivateStatus;
  const needStreamTokenForExclusivePrivatePerforming =
    isExclusivePrivatePerforming && !hasStreamToken;

  const isExclusivePrivateOngoing = [
    ExclusivePrivateStatus.PERFORMING,
    ExclusivePrivateStatus.PREPARING,
  ].includes(exclusivePrivateStatus);

  const isKaraokeDeviceOnline = getIsToyDeviceOnline(state, streamId);

  const activeStreamId = getOperationData(
    state,
    ['liveStream'],
    'activeStreamId'
  );
  const provider = getLiveStreamData(state, [activeStreamId], 'provider');
  // only allow slider for Agora and Tencent player
  const isRenderSlider =
    getIsAgoraStreamProvider({ provider }) ||
    getIsTencentStreamProvider({ provider });

  return {
    streamStatus,
    volume: getOperationData(state, ['player'], 'volume'),
    isMuted: getOperationData(state, ['player'], 'isMuted'),
    isAsideExpanded: getOperationData(
      state,
      ['liveStream', 'panel'],
      'isAsideExpanded'
    ),
    isTriggerPrivateModalOpen:
      getModalData(state, 'LiveStreamTriggerPrivateModal', 'status') ===
      'display',
    isGiftModalOpen:
      getModalData(state, 'LiveStreamGiftModal', 'status') === 'display',
    hasStreamToken,
    needStreamTokenForExclusivePrivatePerforming,
    privateShowStatus: getPrivateShowStatus(state, streamId),
    isKaraokeDeviceOnline,
    isKaraokeModalOpen: ['display', 'opening'].includes(
      getModalData(state, 'LiveStreamKaraokeModal', 'status')
    ),
    isExclusivePrivateOngoing,
    isRenderSlider,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setMuted: data => dispatch(setPlayerData(data)),
    setVolume: data => dispatch(setPlayerData(data)),
    setAsideExpended: ({ isAsideExpanded }) =>
      dispatch(setLiveStreamPanel({ isAsideExpanded })),
    toggleModal: data => dispatch(toggleModal(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LivestreamDetailOnlineFooterDesktop);
